import React from 'react';
import styled from 'styled-components';
import { func, bool } from 'prop-types';

const Label = styled.label`
  position: relative;
  display: inline-block;
  width: 56px;
  height: 24px;

  input[type="checkbox"] {
    opacity: 0;
    width: 56px;
    height: 24px;
  }
`;

const Toggle = styled.span`
  border-radius: 34px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #9027b0;
  transition: 0.4s;
  &:before {
    border-radius: 50%;
    position: absolute;
    cursor: pointer;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: #fff;
    transition: 0.4s;
  }
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  &:checked + span:before {
    transform: translateX(32px);
  }
`;

const SwitchButton = ({ onClick, active }) => (
  <Label>
    <Checkbox defaultChecked={active} onClick={onClick} />
    <Toggle />
  </Label>
);

SwitchButton.propTypes = {
  onClick: func.isRequired,
  active: bool,
};

SwitchButton.defaultProps = {
  active: false,
};

export default SwitchButton;
